import { Expose } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString } from "class-validator";

export class BookingItemToImport {
  @Expose()
  @IsString()
  currency!: string;
  @Expose()
  @IsString()
  exchangeDate!: string;
  @Expose()
  @IsNumber()
  exchangeRateFromBookingItemToAppBaseCurrency!: number;
  @Expose()
  @IsNumber()
  exchangeRateFromOrderToAppBaseCurrency!: number;
  @Expose()
  @IsNumber()
  fareBase!: number;
  @Expose()
  @IsNumber()
  fareBaseAfterCalculate!: number;
  @Expose()
  @IsNumber()
  fareBaseInAppCurrency!: number;
  @Expose()
  @IsOptional()
  @IsString()
  firstNumber!: string | null;
  @Expose()
  @IsNumber()
  grandTotal!: number;
  @Expose()
  @IsNumber()
  grandTotalAfterCalculate!: number;
  @Expose()
  @IsNumber()
  grandTotalInAppCurrency!: number;
  @Expose()
  @IsString()
  guid!: string;
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsBoolean()
  isManualExchangeRate!: boolean;
  @Expose()
  @IsBoolean()
  isRequireCalculationFromBaseCurrency!: boolean;
  @Expose()
  @IsBoolean()
  isRequireCalculationToBaseCurrency!: boolean;
  @Expose()
  @IsBoolean()
  isVisible!: boolean;
  @Expose()
  @IsString()
  orderCurrency!: string;
  @Expose()
  @IsOptional()
  @IsString()
  recordLocator!: string | null;
}

export type BookingItemToConversion = Array<BookingItemToImport>;
